/**
 * @flow
 * @relayHash 9fbe38fe56c95bf2bc9dc49f93c9474f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteChecklistItemInput = {|
  clientMutationId?: ?string,
  context: MutationContext,
  checklistItemId: string,
|};
export type MutationContext = {|
  organizationId: string
|};
export type DeleteChecklistItemMutationVariables = {|
  input: DeleteChecklistItemInput
|};
export type DeleteChecklistItemMutationResponse = {|
  +deleteChecklistItem: ?{|
    +deletedChecklistItemId: string
  |}
|};
export type DeleteChecklistItemMutation = {|
  variables: DeleteChecklistItemMutationVariables,
  response: DeleteChecklistItemMutationResponse,
|};
*/


/*
mutation DeleteChecklistItemMutation(
  $input: DeleteChecklistItemInput!
) {
  deleteChecklistItem(input: $input) {
    deletedChecklistItemId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteChecklistItemPayload",
    "kind": "LinkedField",
    "name": "deleteChecklistItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedChecklistItemId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteChecklistItemMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteChecklistItemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9fbe38fe56c95bf2bc9dc49f93c9474f",
    "metadata": {},
    "name": "DeleteChecklistItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a59db21f2005d610bbac3db44ea75cfe';

module.exports = node;
